import { useEffect } from "react"
import extractHtmlAndScripts, { type ExtractHtmlAndScriptsResult } from "@/utils/extractHtmlAndScripts"

function addScriptFromString(scriptString: string, id: string): Promise<void> {
    return new Promise(resolve => {
        try {
            const template = document.createElement("template")
            template.innerHTML = scriptString.trim()
            const scriptEl = template.content.firstChild as HTMLScriptElement

            if (scriptEl?.tagName === "SCRIPT") {
                const newScript = document.createElement("script")
                const elComponent = document.getElementById(id)

                if (!elComponent) {
                    console.error(`Elemento id ${id} não encontrado`)
                    return null
                }

                Array.from(scriptEl.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value)
                })

                // script externo. Garante que a promise seja resolvida somente quando a lib seja baixada
                if (scriptEl.src) {
                    newScript.onload = () => resolve() // resolve a promise quando finaliza o carregamento
                    newScript.onerror = () => resolve() // resolve a promise quando ocorrer erro
                    elComponent.appendChild(newScript) // injeta o script e resolve a promise
                } else {
                    // script inline
                    newScript.textContent = scriptEl.textContent
                    elComponent.appendChild(newScript)
                    resolve()
                }
            } else {
                resolve()
            }
        } catch (error) {
            console.error(error)
            resolve()
        }
    })
}

function addLinkRelFromString(linkString: string, id: string): Promise<void> {
    return new Promise(resolve => {
        try {
            const template = document.createElement("template")
            template.innerHTML = linkString.trim()
            const linkEl = template.content.firstChild as HTMLElement

            if (linkEl.tagName === "LINK") {
                const newLink = document.createElement("link")

                Array.from(linkEl.attributes).forEach(attr => {
                    newLink.setAttribute(attr.name, attr.value)
                })

                newLink.dataset.origin = id

                newLink.onload = () => resolve()
                newLink.onerror = () => resolve()
                document.head.appendChild(newLink)
            } else {
                resolve()
            }
        } catch (error) {
            console.error(error)
            resolve()
        }
    })
}


export function Html({ html, id, links, scripts }: ExtractHtmlAndScriptsResult & { id: string }) {

    useEffect(() => {
        const element = document.getElementById(id)
        if (element) {
            element.innerHTML = html
        }

        if (links.length) {
            for (const link of links) {
                addLinkRelFromString(link, id)
            }
        }

        if (scripts.length) {
            (async () => {
                for (const script of scripts) {
                    addScriptFromString(script, id)
                }
            })()
        }

    }, [id, html, scripts, links])

    return null
}

export default class HtmlApp {
    constructor({ id, html }: { id: string; html: string }) {
        const el = document.getElementById(id)
        if (!el) return

        const data = extractHtmlAndScripts(html)
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<Html {...data} id={id} />)
    }
}